import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import ExportPdfTimeCommand from '../../commands/hub/export.pdf.time.command';
import { HubCalendarActionCommand } from '../../commands/pagination.query.command';
import { ButtonTriggerEvent } from '../../common/components';
import { BaseComponent } from '../../common/components/base.component';
import { EventTimeService } from '../../services/event.time.service';
import { ImageService } from '../../services/image.service';
import { ExportPdfModalComponent } from './export.pdf.modal/export.pdf.modal.component';
import {
  ExportPdfModalActions,
  ExportPdfModalData,
  LogoCommand,
  PDFSettingCommand,
} from './export.pdf.modal/export.pdf.modal.provider';
import { getRouteUrl, routeConfigs } from '../../common/constants/route.config';
import { AuthService } from '../../common/services/auth.service';
import { ModalService } from '../../common/services/modal.service';
import { HubEvent } from '../../models/hub/hub.event';
import { HubPlace } from '../../models/hub/hub.place';
import { CustomizationApiService } from '../../services/customization.api.service';
import { HubApiService } from '../../services/hub.api.service';
import {
  HubCalendarStore,
  HubCalendarEventsStore,
  HubCalendarPlacesStore,
  HubExportPdfStore,
  HubLogoStore,
  PDFSettingsStore,
} from '../../stores/hub.calendar.store';
import { ExportService, PDFType } from '../../services/export.csv.service';
import { config } from '../../../config/config';
import { HubNavigatorComponent } from './side.bar/hub.side.bar.component';
import { VisitorApiService } from '../../services/visitor.api.service';
import { ConfirmModalActions, ConfirmModalData } from '../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../common/components/confirm.modal/confirm.modal.component';

@Component({
  styleUrls: ['./hub.component.scss'],
  templateUrl: './hub.component.html',
})
export class HubComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public location: string;
  public command = new HubCalendarActionCommand();
  public events = Array<HubEvent>();
  public places = Array<HubPlace>();
  public exportFilename = config.exportFilename;
  public columns = config.columns;
  public exportPdfCommand: ExportPdfModalData;
  public logoUrl: any;
  public logo: LogoCommand;
  public pdfSettings = new PDFSettingCommand();
  public imgoingLogo = config.newDesignLogoUrl;
  public exportPDFMaxItemCount = 100;
  @ViewChild('sidebar') public sidebar: HubNavigatorComponent;

  constructor(
    private router: Router,
    private authService: AuthService,
    private hubApiService: HubApiService,
    private exportService: ExportService,
    private hubCalendarStore: HubCalendarStore,
    private hubCalendarEventsStore: HubCalendarEventsStore,
    private hubCalendarPlacesStore: HubCalendarPlacesStore,
    private hubExportPdfStore: HubExportPdfStore,
    private modalService: ModalService,
    private imageService: ImageService,
    private hubLogoStore: HubLogoStore,
    private apiService: VisitorApiService,
    private pdfSettingsStore: PDFSettingsStore,
    private customizationService: CustomizationApiService,
    private activatedRoute: ActivatedRoute
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.imgoingLogo = this.imageService.imageSourceUrl(this.imgoingLogo);

    this.hubLogoStore.logoCommand.takeUntil(this.isDestroyed).subscribe((logo: LogoCommand) => {
      this.logoUrl =
        isNullOrUndefined(logo) || isNullOrUndefined(logo.isDefault) || logo.isDefault
          ? config.defaultLogoUrl
          : logo.url;
      this.logo = logo;
    });

    // this.pdfSettingsStore.pdfCommand
    //     .takeUntil(this.isDestroyed)
    //     .subscribe((settings: PDFSettingCommand) => {
    //         if (settings.pdf.headerImage.event.url !== 'not-changed') {
    //             this.pdfSettings.pdf.headerImage.event = settings.pdf.headerImage.event;
    //         }
    //         if (settings.pdf.headerImage.place.url !== 'not-changed') {
    //             this.pdfSettings.pdf.headerImage.place = settings.pdf.headerImage.place;
    //         }
    //         if (settings.eventCalendarURL) {
    //             this.pdfSettings.eventCalendarURL = settings.eventCalendarURL;
    //         }
    //         if (settings.placeCalendarURL) {
    //             this.pdfSettings.placeCalendarURL = settings.placeCalendarURL;
    //         }
    //     });

    this.hubCalendarStore.actionCommand.takeUntil(this.isDestroyed).subscribe((command: HubCalendarActionCommand) => {
      this.command = command;
      this.location =
        (command.queryParams.isApproved ? 'Approved' : 'Unapproved') +
        (this.command.isEventCalendar ? ' Events' : ' Places');
    });
    this.hubCalendarEventsStore.eventsCommand.takeUntil(this.isDestroyed).subscribe((events: HubEvent[]) => {
      this.events = events;
    });
    this.hubCalendarPlacesStore.placesCommand.takeUntil(this.isDestroyed).subscribe((places: HubPlace[]) => {
      this.places = places;
    });

    this.hubExportPdfStore.expoertPdfCommand.takeUntil(this.isDestroyed).subscribe((data: ExportPdfModalData) => {
      this.exportPdfCommand = data;
    });
  }

  //   public downloadCSV() {
  //     if (this.command.isEventCalendar) {
  //       let temp = this.events.map((x) => {
  //         return {
  //           EventTitle: x.title || x.name,
  //           EventStartTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(
  //             x.startTime,
  //             x.timezoneFormatter
  //           ),
  //           EventEndTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(x.endTime, x.timezoneFormatter),
  //           Image: this.imageService.imageSourceUrl(x.cover ? x.cover.source : null),
  //           Description: x.description,
  //           Venue: x.venue,
  //           EventAddress: x.address ? x.address.address + (x.isHybridEvent ? '(& Virtual)' : '') : '(Virtual Event)',
  //           Host: x.owner.name,
  //           TicketURI: x.ticketUri,
  //           Link: x.eventLink,
  //           HostLink: x.hostLink,
  //         };
  //       });
  //       this.exportService.exportCSV(temp, this.columns.events, this.exportFilename.events);
  //     } else {
  //       let temp = this.places.map((x) => {
  //         return {
  //           PlaceTitle: x.title,
  //           PlaceCategory: x.category,
  //           Image: x.image,
  //           Description: x.description,
  //           PlaceAddress: x.address,
  //           PlaceEmails: x.emails,
  //           PlacePhone: x.phone,
  //           PlaceWebsite: x.website,
  //           PlaceLikes: x.likes,
  //           PlaceCheckins: x.checkins,
  //           Link: x.hostLink,
  //         };
  //       });
  //       this.exportService.exportCSV(temp, this.columns.places, this.exportFilename.places);
  //     }
  //   }

  public downloadPDF() {
    this.showPDFPopup();
  }

  public navigateToSupport() {
    window.open('https://itidigital.freshdesk.com/support/home', '_blank');
  }

  public goEditAccount() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.editAccount, {
        hubName: this.hubName,
      })
    );
  }

  public logout() {
    this.authService.logout();
    this.router.navigateByUrl(getRouteUrl(routeConfigs.auth.login));
  }

  private recordExportTime(itemExportCount: number) {
    if (config.isAnalyticsOn) {
      this.hubApiService
        .recordExportPdfTime(
          this.hubName,
          new ExportPdfTimeCommand(
            this.hubName,
            this.exportPdfCommand.isEvent ? 'event' : 'place',
            this.exportPdfCommand.isEvent ? this.exportPdfCommand.eventSource : this.exportPdfCommand.placeSource,
            this.exportPdfCommand.from,
            this.exportPdfCommand.to,
            this.exportPdfCommand.isPrintVersion ? 'print' : 'online',
            this.exportPdfCommand.category,
            itemExportCount
          )
        )
        .subscribe((x) => {});
    }
  }

  public exportCSV(items: any[]) {
    if (this.exportPdfCommand.isEvent) {
      let temp = items.map((x) => {
        return {
          Title: x.title || x.name,
          StartTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(x.startTime, x.timezoneFormatter),
          EndTime: EventTimeService.convertByTimezoneFormatterIncludeNoTimeCheck(x.endTime, x.timezoneFormatter),
          StartTimeISO: x.startTime,
          EndTimeISO: x.endTime,
          Image: this.imageService.imageSourceUrl(x.cover ? x.cover.source : null),
          Description: x.description,
          Venue: x.venue,
          Address: x.address ? x.address.address + (x.isHybridEvent ? '(& Virtual)' : '') : '(Virtual Event)',
          Organizer: x.owner.name,
          TicketURI: x.ticketUri,
          Link: x.eventLink,
          OrganizerLink: x.hostLink,
        };
      });
      this.exportService.exportCSV(temp, this.columns.events, this.exportFilename.events);
    } else {
      let temp = items.map((x) => {
        return {
          Title: x.title,
          Category: x.category,
          Image: this.imageService.imageSourceUrl(x.cover ? x.cover.source : null),
          Description: x.description,
          Address: x.address.address || x.address,
          Email: x.emails,
          Phone: x.phone,
          Website: x.website,
          Rating: x.rating,
          PriceRange: x.priceRange,
          Link: x.hostLink,
          GooglePlaceId: x.id,
          ApprovalStatus: x.isApproved ? 'Approved' : 'Unapproved',
        };
      });
      this.exportService.exportCSV(temp, this.columns.places, this.exportFilename.places);
    }
  }

  public showPDFPopup() {
    let actions = <ExportPdfModalActions>{
      confirm: (event: ButtonTriggerEvent, progressCallback: (progress) => void) => {
        let itemExportCount = 0;
        this.customizationService.getStyleAndPDFSettingsForHub(this.hubName).subscribe((settings) => {
          if (this.exportPdfCommand.isEvent) {
            this.hubApiService.getEvents(this.hubName, this.exportPdfCommand).subscribe((data) => {
              if (this.exportPdfCommand.exportType === 'CSV') {
                this.exportCSV(data);
                event.complete();
                return;
              }

              const exportEventPDF = (logoBase64) => {
                this.exportService.exportPDF(
                  data,
                  PDFType.event,
                  this.exportPdfCommand.isPrintVersion,
                  settings.pdf.headerImage.event.isDefault ? null : settings.pdf.headerImage.event.url[0],
                  isNullOrUndefined(settings.logo.isDefault) || settings.logo.isDefault ? null : logoBase64,
                  settings.eventCalendarURL,
                  settings.placeCalendarURL,
                  settings.moreToursURL,
                  this.exportPdfCommand.from,
                  this.exportPdfCommand.to,
                  '',
                  settings.style.eventButton.backgroundColor,
                  event,
                  (progress) => {
                    if (progressCallback) {
                      progressCallback(progress + '%');
                    }
                  }
                );
              };

              const loadLogoAndExport = () => {
                if (this.logoUrl) {
                  // images from Amazon S3 has CORS problems (have already set in the Amazon dashboard, but still not work), so here is to get the image base64 from server side
                  if (this.logoUrl.includes('s3.amazonaws.com')) {
                    this.apiService.getImageBase64(this.logoUrl).subscribe((base64Data) => {
                      let base64;
                      if (base64Data && base64Data.succeed) {
                        base64 = base64Data.base64;
                      } else {
                        console.error('logo base64 not get');
                        return;
                      }
                      exportEventPDF(base64);
                    });
                  } else {
                    // images from ImGoing server, get base64 locally
                    this.imageService.geetBase64ImageByUrl(this.logoUrl).then((base64) => {
                      exportEventPDF(base64);
                    });
                  }
                } else {
                  exportEventPDF(null);
                }
              };

              if (
                data.length > this.exportPDFMaxItemCount &&
                !this.exportPdfCommand.from &&
                !this.exportPdfCommand.to &&
                !this.exportPdfCommand.isToBeExport &&
                !this.exportPdfCommand.choice
              ) {
                const msg = `Exporting all events at once may result in slow loading or freezing due to the large data volume. For a faster, smoother experience, we recommend using filters to export events in smaller, manageable groups. Thank you for your understanding!`;
                let actions = <ConfirmModalActions>{
                  confirm: (feed: ButtonTriggerEvent) => {
                    // data = data.slice(0, this.exportPDFMaxItemCount);
                    loadLogoAndExport();
                  },
                  cancel: (feed: ButtonTriggerEvent) => {
                    event.immediateComplete();
                  },
                };

                const modalData = <ConfirmModalData>{
                  confirmModalIcon: 'info',
                  confirmModalTitle: 'Alert',
                  confirmModalDescription: msg,
                  confirmModalConfirmButtonText: 'Export',
                  confirmModalCancelButtonText: 'Cancel',
                  // confirmCheckboxDescription: `You’re exporting a large number of events. To prevent issues, only the first ${this.exportPDFMaxItemCount} events will be exported.`,
                  isAsync: false,
                };

                this.modalService.show({
                  component: ConfirmModalComponent,
                  providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: modalData },
                  ],
                });

                return;
              }

              loadLogoAndExport();
              this.recordExportTime(itemExportCount);
            });
          } else {
            this.exportPdfCommand.source = settings.dataSource.place || 'facebook';
            // Google place images need to get their real url, otherwise they cannot get the base64 format data
            this.exportPdfCommand.convertImgUrl = this.exportPdfCommand.source === 'google';
            this.hubApiService.getPlaces(this.hubName, this.exportPdfCommand).subscribe((data) => {
              if (this.exportPdfCommand.exportType === 'CSV') {
                this.exportCSV(data);
                event.complete();
                return;
              }

              let placeCalendarURL = settings.placeCalendarURL;
              if (this.exportPdfCommand.category_id && settings.placeURLs && settings.placeURLs.length > 0) {
                let placeURL = settings.placeURLs.find((x) => x.igURL.indexOf(this.exportPdfCommand.category_id) > -1);
                if (placeURL) {
                  placeCalendarURL = placeURL.clientURL;
                }
              }

              const exportPlacePDF = (logoBase64) => {
                this.exportService.exportPDF(
                  data,
                  PDFType.place,
                  this.exportPdfCommand.isPrintVersion,
                  settings.pdf.headerImage.place.isDefault ? null : settings.pdf.headerImage.place.url[0],
                  isNullOrUndefined(settings.logo.isDefault) || settings.logo.isDefault ? null : logoBase64,
                  settings.eventCalendarURL,
                  placeCalendarURL,
                  settings.moreToursURL,
                  null,
                  null,
                  this.exportPdfCommand.subTitle,
                  settings.style.eventButton.backgroundColor,
                  event,
                  (progress) => {
                    if (progressCallback) {
                      progressCallback(progress + '%');
                    }
                  }
                );
              };

              const loadLogoAndExport = () => {
                if (this.logoUrl) {
                  // images from Amazon S3 has CORS problems (have already set in the Amazon dashboard, but still not work), so here is to get the image base64 from server side
                  if (this.logoUrl.includes('s3.amazonaws.com')) {
                    this.apiService.getImageBase64(this.logoUrl).subscribe((base64Data) => {
                      let base64;
                      if (base64Data && base64Data.succeed) {
                        base64 = base64Data.base64;
                      } else {
                        console.error('logo base64 not get');
                        return;
                      }
                      exportPlacePDF(base64);
                    });
                  } else {
                    // images from ImGoing server, get base64 locally
                    this.imageService.geetBase64ImageByUrl(this.logoUrl).then((base64) => {
                      exportPlacePDF(base64);
                    });
                  }
                } else {
                  exportPlacePDF(null);
                }
              };

              if (
                data.length > this.exportPDFMaxItemCount &&
                !this.exportPdfCommand.category_id &&
                !this.exportPdfCommand.isToBeExport &&
                !this.exportPdfCommand.choice
              ) {
                const msg = `Exporting all places at once may result in slow loading or freezing due to the large data volume. For a faster, smoother experience, we recommend using category filters to export places in smaller, manageable groups. Thank you for your understanding!`;
                let actions = <ConfirmModalActions>{
                  confirm: (feed: ButtonTriggerEvent) => {
                    // data = data.slice(0, this.exportPDFMaxItemCount);
                    loadLogoAndExport();
                  },
                  cancel: (feed: ButtonTriggerEvent) => {
                    event.immediateComplete();
                  },
                };

                const modalData = <ConfirmModalData>{
                  confirmModalIcon: 'info',
                  confirmModalTitle: 'Alert',
                  confirmModalDescription: msg,
                  confirmModalConfirmButtonText: 'Export',
                  confirmModalCancelButtonText: 'Cancel',
                  // confirmCheckboxDescription: `You’re exporting a large number of places. To prevent issues, only the first ${this.exportPDFMaxItemCount} places will be exported.`,
                  isAsync: false,
                };

                this.modalService.show({
                  component: ConfirmModalComponent,
                  providers: [
                    { provide: ConfirmModalActions, useValue: actions },
                    { provide: ConfirmModalData, useValue: modalData },
                  ],
                });

                return;
              }

              loadLogoAndExport();

              this.recordExportTime(itemExportCount);
            });
          }
        });
      },
    };

    let data = <ExportPdfModalData>{
      isAsync: true,
    };

    this.modalService.show({
      component: ExportPdfModalComponent,
      providers: [
        { provide: ExportPdfModalActions, useValue: actions },
        { provide: ExportPdfModalData, useValue: data },
      ],
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/hub.component.ts